import { addMonths, cadenceMonthLabel } from "../CadenceCalendar.helpers.ts";

type CadenceHeaderProps = {
  month: string;
  loading: boolean;
  onMonthChange: (month: string) => void;
  onOpenScheduler: () => void;
  onReload: () => void;
};

export function CadenceHeader({
  month,
  loading,
  onMonthChange,
  onOpenScheduler,
  onReload,
}: CadenceHeaderProps) {
  return (
    <header className="cadence-head">
      <div>
        <span className="cadence-eyebrow">Cadencia</span>
        <h1>Calendario</h1>
      </div>
      <div className="cadence-month-controls" aria-label="Navegar meses">
        <button type="button" onClick={() => onMonthChange(addMonths(month, -1))}>Anterior</button>
        <strong>{cadenceMonthLabel(month)}</strong>
        <button type="button" onClick={() => onMonthChange(addMonths(month, 1))}>Proximo</button>
        <button type="button" onClick={onOpenScheduler}>Adicionar cadencia</button>
        <button type="button" onClick={onReload} disabled={loading}>Atualizar</button>
      </div>
    </header>
  );
}
